"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CourtPositionEnum = void 0;
var CourtPositionEnum;
(function (CourtPositionEnum) {
    CourtPositionEnum["BASELINE"] = "BASELINE";
    CourtPositionEnum["LEFT_SERVICE_COURT"] = "LEFT_SERVICE_COURT";
    CourtPositionEnum["NET"] = "NET";
    CourtPositionEnum["RIGHT_SERVICE_COURT"] = "RIGHT_SERVICE_COURT";
    CourtPositionEnum["SERVICELINE"] = "SERVICELINE";
})(CourtPositionEnum || (exports.CourtPositionEnum = CourtPositionEnum = {}));
//# sourceMappingURL=court_position_names.js.map